import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/** La hoja de confirmación del cierre. A pedido, por la adjudicación 41. */
export const rutaCierre = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/jornada/cierre',
  component: lazyRouteComponent(
    () => import('../../funcionalidades/cierre-reparto/PaginaCierre.js'), 'PaginaCierre'),
});
